import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { usePortal } from 'lib/portal'

const ActivityPlanDetailHeaderContext = createContext(null)

export const ActivityPlanDetailHeaderProvider = ({ children }) => {
  const [detailTitle, setDetailTitle] = useState(null)
  const [detailSubtitle, setDetailSubtitle] = useState(null)
  const [HeaderActionsPortal, actionsTarget] = usePortal()

  const clearDetailHeader = useCallback(() => {
    setDetailTitle(null)
    setDetailSubtitle(null)
  }, [])

  const value = useMemo(
    () => ({
      detailTitle,
      detailSubtitle,
      setDetailTitle,
      setDetailSubtitle,
      clearDetailHeader,
      HeaderActionsPortal,
      actionsTarget,
    }),
    [
      detailTitle,
      detailSubtitle,
      clearDetailHeader,
      HeaderActionsPortal,
      actionsTarget,
    ],
  )

  return (
    <ActivityPlanDetailHeaderContext.Provider value={value}>
      {children}
    </ActivityPlanDetailHeaderContext.Provider>
  )
}

export const useActivityPlanDetailHeader = () => {
  const context = useContext(ActivityPlanDetailHeaderContext)

  if (!context) {
    throw new Error(
      'useActivityPlanDetailHeader must be used within ActivityPlanDetailHeaderProvider',
    )
  }

  return context
}

export const useOptionalActivityPlanDetailHeader = () =>
  useContext(ActivityPlanDetailHeaderContext)
